<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import { fetchRole, createRole, updateRole } from '@apis/admin/acs'
import { fetchEndpoints } from '@apis/admin/endpoint'
import LangItem from '@components/admin/lang-input'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import filter from 'lodash/filter'

export default {
  components: { LangItem },
  props: {
    role_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      info: null,
      endpoints: [],
      loading: false,
      active_tab: 'info',
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadRole(), this.loadEndpoints()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadRole() {
      const { role_info } = await fetchRole(this.role_seq)
      this.params = defaults(role_info, {
        seq: null,
        name: '',
        title: '',
        use_script: 'N',
        script: '',
      })
      this.info = role_info
    },
    async loadEndpoints() {
      const { data } = await fetchEndpoints()

      this.endpoints = filter(data, { is_admin: true })
      this.filtered_endpoints = this.endpoints
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updateRole : createRole
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('admin.msg_role_modify')
        : this.$t('admin.msg_role_enroll')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <el-tabs v-model="active_tab" :stretch="true">
    <el-tab-pane :label="$t('admin.default_info')" name="info">
      <form
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleSubmit"
      >
        <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row"
                ><div>{{ $t('admin.user_name') }}</div></th
              >
              <td>
                <template v-if="params.seq">{{ params.name }}</template>
                <input
                  v-else
                  v-model="params.name"
                  type="text"
                  :class="[$style.inputTypeText]"
                />
              </td>
              <th scope="row"
                ><div>{{ $t('admin.title') }}</div></th
              >
              <td
                ><LangItem v-if="!loading" v-model="params.title"></LangItem
              ></td>
            </tr>
            <tr>
              <th scope="row"
                ><div>{{ $t('admin.endpoint') }}</div></th
              >
              <td colspan="3">
                <template v-if="params.seq">
                  {{ params.endpoint_method }}: {{ params.endpoint_path }}
                </template>
                <el-select
                  v-else
                  v-model="params.endpoint_id"
                  filterable
                  style="display: block;"
                  :placeholder="$t('admin.endpoint_select')"
                >
                  <el-option
                    v-for="item in filtered_endpoints"
                    :key="item.id"
                    :label="`${item.method}: ${item.path}`"
                    :value="item.id"
                  >
                    <span
                      style=" display: inline-block;float: left; font-size: 13px; color: #8492a6;"
                      >{{ item.method }}</span
                    >
                    <span style="float: right;">{{ item.path }}</span>
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <th colspan="4" scope="row"
                ><div :class="[$style.tCenter]"
                  ><label
                    ><input
                      v-model="params.use_script"
                      type="checkbox"
                      false-value="N"
                      true-value="Y"
                    />
                    {{ $t('admin.use_script') }}</label
                  ></div
                ></th
              >
            </tr>
            <tr v-if="params.use_script === 'Y'">
              <td colspan="4"
                ><div :class="[$style.tCenter]"
                  ><textarea
                    v-model="params.script"
                    :class="[$style.inputTypeTextArea, $style.fullWidth]"
                  ></textarea></div
              ></td>
            </tr>
            <tr>
              <th colspan="4" :class="$style.button">
                <span :class="[$style.button, $style.black]"
                  ><input
                    type="submit"
                    :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
                /></span>
              </th>
            </tr>
          </tbody>
        </table>
      </form>
    </el-tab-pane>
  </el-tabs>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
